import { isDate as isDateOriginal } from 'date-fns'

/**
 * Checks if `value` is an Invalid Date object.
 * @param {unknown} value the value to check.
 * @returns {boolean} `true` if `value` is an Invalid Date object.
 */
export const isInvalidDateObject = (value: unknown): boolean =>
  value instanceof Date && Number.isNaN(value.getTime())

/**
 * Performs date-fns isDate check with type narrowing.
 * @param {unknown} value the value to check
 * @returns {boolean} true if value is a date
 */
export const isDate = (value: unknown): value is Date =>
  isDateOriginal(value) && !isInvalidDateObject(value)

/**
 * Checks if `value` is a date or number with type narrowing.
 * Uses date-fns isDate to check for date.
 * @param {unknown} value the value to check.
 * @returns {boolean} `true` if `value` is a `date` or `number`.
 */
export const isDateOrNumber = (value: unknown): value is Date | number =>
  isDate(value) || typeof value === 'number'
